
/*
This abstract class is a wrapper around all things that we could store in the document.

Since the stored items get written out to the document's custom.xml, we should ensure that any new
settings added here go through Word's file format update process.
*/

import { ErrorStringFromException, isNullOrUndefined } from '../../utils/utils';
import { DocumentStorageError, DocumentStorageErrors } from './DocumentStorageErrors';
import { HostAppSettingName, HostAppSettings } from './HostAppSettings';
import { TranscriptionStorageType } from '../interfaces/IStoredTranscription';

/*
VSO:3702626 tracks following up with Word's file format team for this.
*/

export abstract class DocumentStorage {

  readonly SupportedDocumentStorageType: TranscriptionStorageType | null = null;

  abstract WriteTranscribeContentToClient(content: string): Promise<void>;
  abstract DeleteTranscribeContentFromClient(): Promise<void>;

  constructor(storageType: TranscriptionStorageType) {
    this.SupportedDocumentStorageType = storageType;
  }

  GetStoredTranscription(): any {
    let storedTranscription: string | object | null = null;
    try {
      storedTranscription = HostAppSettings.GetSetting(HostAppSettingName.StoredTranscription);
      const storedTranscriptionJson = typeof storedTranscription == 'object' ? storedTranscription : JSON.parse(storedTranscription);
      return storedTranscriptionJson;
    } catch (e) {
      let storedTranscriptionString: string = typeof storedTranscription == 'object' ? JSON.stringify(storedTranscription) : storedTranscription;

      // Adding suffix error message to provide more information about
      // transcription string property
      const suffixErrorMessage = isNullOrUndefined(storedTranscriptionString)
        ? ', Stored transcription string is Undefined'
        : ', Stored transcription string has length : ' + storedTranscriptionString.length;

      throw new DocumentStorageError(DocumentStorageErrors.CorruptTranscriptSource, ErrorStringFromException(e) + suffixErrorMessage);
    }
  }
}
